import {
  Box,
  Container,
  Heading,
  Text,
  Image,
  Stack,
  Button,
  SimpleGrid,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import RegistersImage from "./images/registers1.png";
import HeroImage from "./images/stamps.png";

const RegistersDescription = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Navbar />

      {/* Background image */}
      <Image
        src={HeroImage}
        alt="Hero Watermark"
        width="100%"
        height="100%"
        objectFit="cover"
        opacity={0.30}
        position="absolute"
        top={0}
        left={0}
        zIndex={-1}
        filter="blur(1px)"
      />

      <Container maxW="container.xl" py={8}>
        <Stack spacing={8} align="stretch">
          {/* Header Section */}
          <Box
            bg="rgba(255,255,255,0.95)"
            p={12}
            borderRadius="lg"
            boxShadow="xl"
            textAlign="center"
          >
            <Image
              src={RegistersImage}
              alt="Registers"
              maxW="400px"
              mx="auto"
              mb={6}
            />
          </Box>

          {/* Main Content */}
          <Box
            bg="rgba(255,255,255,0.95)"
            p={10}
            borderRadius="lg"
            boxShadow="xl"
          >
            <Heading size="lg" mb={6} color="gray.800">
              Asset Register Design & Management
            </Heading>

            <Text fontSize="lg" mb={6} lineHeight="1.8" color="gray.700">
              Define and manage asset information that supports your contracts with flexible frameworks and external connectivity.
            </Text>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8} mb={8}>
              <Box>
                <Heading size="lg" color="pink.600" mb={4}>
                  Key Capabilities
                </Heading>
                <Stack spacing={4}>
                  <Box p={4} bg="pink.50" borderRadius="md">
                    <Text color="gray.700" fontSize="md">
                      Standardized asset frameworks
                    </Text>
                  </Box>

                  <Box p={4} bg="pink.50" borderRadius="md">
                    <Text color="gray.700" fontSize="md">
                      Comprehensive asset management
                    </Text>
                  </Box>

                  <Box p={4} bg="pink.50" borderRadius="md">
                    <Text color="gray.700" fontSize="md">
                      Contract integration
                    </Text>
                  </Box>

                  <Box p={4} bg="pink.50" borderRadius="md">
                    <Text color="gray.700" fontSize="md">
                      Event-driven updates
                    </Text>
                  </Box>

                  <Box p={4} bg="pink.50" borderRadius="md">
                    <Text color="gray.700" fontSize="md">
                      Data ownership
                    </Text>
                  </Box>
                </Stack>
              </Box>

              <Box>
                <Heading size="lg" color="pink.600" mb={4}>
                  Description
                </Heading>
                <Box p={4} bg="pink.50" borderRadius="md">
                  <Text color="gray.700" fontSize="md" lineHeight="1.8">
                    Registers provides a flexible framework for defining and managing assets within your insurance operations, ensuring consistency and enabling dynamic contract behavior.
                  </Text>
                </Box>

                <Heading size="md" color="pink.600" mb={3} mt={6}>
                  Benefits
                </Heading>
                <Stack spacing={3}>
                  <Box p={3} bg="pink.50" borderRadius="md">
                    <Text color="gray.700" fontSize="sm">
                      Asset definition and management
                    </Text>
                  </Box>

                  <Box p={3} bg="pink.50" borderRadius="md">
                    <Text color="gray.700" fontSize="sm">
                      Rapid configuration
                    </Text>
                  </Box>

                  <Box p={3} bg="pink.50" borderRadius="md">
                    <Text color="gray.700" fontSize="sm">
                      Contract connectivity
                    </Text>
                  </Box>

                  <Box p={3} bg="pink.50" borderRadius="md">
                    <Text color="gray.700" fontSize="sm">
                      External system integration
                    </Text>
                  </Box>
                </Stack>
              </Box>
            </SimpleGrid>

            <Box textAlign="center" mt={8}>
              <Button
                colorScheme="pink"
                size="lg"
                onClick={() => navigate("/registers")}
                boxShadow="lg"
                _hover={{ transform: "scale(1.05)" }}
                transition="all 0.2s"
              >
                Explore Registers
              </Button>
            </Box>
          </Box>

        </Stack>
      </Container>
    </Box>
  );
};

export default RegistersDescription;
